import { useEffect } from 'react';

/**
 * Keeps `<title>` in step with what is on screen.
 *
 * `index.html` ships a static English title, which a screen reader announces before anything else and which a
 * guest sees in their tab list and share sheet. Left alone it reads out English over a Spanish page — a
 * WCAG 2.4.2 failure, and the first thing a Spanish-speaking guest would hear.
 *
 * Deliberately called by each screen rather than once from the TranslationProvider. React runs child effects
 * before parent ones, so a provider-level writer would run *after* the screen's and clobber the more specific
 * title every time the language changed. One writer per rendered screen has no such ordering to get wrong.
 */
export function useDocumentTitle(title: string): void {
    useEffect(() => {
        document.title = title;
    }, [title]);
}
